import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Category } from '../../../models/category.model';
import { CategoryService } from '../../../services/category.service';
import { CategoryIconComponent } from '../../../shared/components/category-icon/category-icon.component';
import { CategoryEnvBadgeComponent } from '../../../shared/components/category-env-badge/category-env-badge.component';

/**
 * Card-grid category selector (design variant 1a "Kategorie-Karten").
 *
 * Consumes the categories already fetched by CategorySelectorComponent via
 * CategoryService.categories$ — it deliberately performs no HTTP call of its
 * own, so it must be rendered alongside (or after) the dropdown selector,
 * which owns the fetch.
 */
@Component({
  selector: 'app-simplified-category-selector',
  standalone: true,
  imports: [CategoryIconComponent, CategoryEnvBadgeComponent],
  templateUrl: './simplified-category-selector.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./simplified-category-selector.component.css']
})
export class SimplifiedCategorySelectorComponent implements OnInit, OnDestroy {
  @Input() selectedCategoryId: string = '';
  @Output() categorySelected = new EventEmitter<Category | null>();

  categories: Category[] = [];

  private categoriesSubscription?: Subscription;

  constructor(private categoryService: CategoryService) {}

  ngOnInit(): void {
    this.categoriesSubscription = this.categoryService.categories$.subscribe(
      categories => (this.categories = categories)
    );
  }

  ngOnDestroy(): void {
    this.categoriesSubscription?.unsubscribe();
  }

  selectCategory(category: Category): void {
    this.categorySelected.emit(category);
  }
}
